import { CreativeXAssetType, CreativeXCampaignType } from "@/enums/platforms";

export default function getDefaultCreativeXCampaignSettings(): {
    marketCode: "";
    channel: "";
    publisher: "";
    placement: "";
    campaignObjective: "";
    contentType: (typeof CreativeXCampaignType)[keyof typeof CreativeXCampaignType];
    adFormat: "";
    assetType: (typeof CreativeXAssetType)[keyof typeof CreativeXAssetType];
} {
    return {
        marketCode: "",
        channel: "",
        publisher: "",
        placement: "",
        campaignObjective: "",
        contentType: CreativeXCampaignType.Brand,
        adFormat: "",
        assetType: CreativeXAssetType.Image
    };
}
